<template>
  <header
    class="form-section-header"
    :class="{'-small': small}"
  >
    <slot>
      <b-row>
        <b-col>
          <BfTitle size="small" tag="h4" class="header-title">{{title}}</BfTitle>
        </b-col>
        <b-col cols="auto" class="header-buttons">
          <slot name="side-content">
            <template v-if="displayButtons">
              <BfButton
                v-for="({icon, type, variant, disabled = false}) in buttons"
                :key="type"
                :variant="variant"
                :disabled="disabled"
                class="header-button"
                @click="buttonClick(type)"
              >
                <i :class="icon" />
              </BfButton>
            </template>
          </slot>
        </b-col>
      </b-row>
    </slot>
  </header>
</template>

<script>
export default {
  name: 'FormSectionHeader',

  props: {
    disableEditButton: {
      type: Boolean,
      default: false,
    },

    disableRemoveButton: {
      type: Boolean,
      default: false,
    },

    displayButtons: {
      type: Boolean,
      default: false,
    },

    small: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
    },
  },

  methods: {
    buttonClick(type) {
      this.$emit('button-click', type);
    },
  },

  computed: {
    buttons() {
      return [
        {
          icon: 'fas fa-plus',
          type: 'add',
          variant: 'primary',
        },
        {
          icon: 'fas fa-pencil-alt',
          type: 'edit',
          variant: 'secondary',
          disabled: this.disableEditButton,
        },
        {
          icon: 'fas fa-minus',
          type: 'remove',
          variant: 'red',
          disabled: this.disableRemoveButton,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.form-section-header {
  padding-bottom: 2px;
  margin-bottom: 30px;

  &.-small {
    padding-bottom: 0;
  }
}

.header-title {
  padding-bottom: 4px;
}

.header-button {
  width: 33px;
  padding-left: 0;
  padding-right: 0;

  &:not(:last-of-type) {
    margin-right: 5px;
  }
}
</style>
